const ForgotTitle = () => {
  return (
    <>
      <h1 className='forgot__title'>Forgot your password?</h1>
      <h2 className='forgot__title-text'>
        No problem! Enter your Email address and we will send you a message to
        generate a new password!
      </h2>
    </>
  )
}

export default ForgotTitle
